<app-dialog-base [showLoadingSpinner]="uiState === uiStateEnumForTemplate.ShowLoading">
  <span dialog-title>Edit QR Code</span>

  <ng-container dialog-content>
    <div class="margin-top-med">
      <div class="text-underline">QR Code Image:</div>
        <img [src]="this.assetManagementService.qrCodeImageUrl" alt="Uploaded Image" style="max-width: 300px;"/>
        <input type="file"
               accept=".png"
               class="file-input display-none"
               (change)="onQrCodeFileSelected($event)" #qrfileUpload>

        <div class="margin-top-med">
          <button color="primary" mat-raised-button
                  (click)="qrfileUpload.click()">
            <mat-icon>attach_file</mat-icon>
            Search images
          </button>

          @if (this.assetManagementService.qrCodeImage) {
            <button class="margin-left-small" color="primary" mat-raised-button (click)="saveQRCode()"
                    data-testid="save-qr-code">
              <mat-icon>save</mat-icon>
              Save QR Code
            </button>
          }
        </div>
    </div>
  </ng-container>
</app-dialog-base>
